import { FunctionComponent, useEffect, useRef, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import {
  selectNotificationStatus,
  hideNotification,
  selectNotificationText,
} from "./notificationBarSlice";

const NotificationBar: FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const status = useAppSelector(selectNotificationStatus);
  const text = useAppSelector(selectNotificationText);
  const [visible, setVisible] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (status === 1) {
      setVisible(true);
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        setVisible(false);
        setTimeout(() => dispatch(hideNotification()), 300);
      }, 2500);
    } else {
      setVisible(false);
    }
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [status, dispatch]);

  if (status !== 1 && !visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 10000,
        display: "flex",
        alignItems: "center",
        gap: "16px",
        backgroundColor: "#358639",
        color: "#ffffff",
        padding: "12px 20px",
        borderRadius: "12px",
        boxShadow: "0 4px 16px rgba(53,134,57,0.30)",
        fontSize: "14px",
        fontWeight: 600,
        whiteSpace: "nowrap",
        opacity: visible ? 1 : 0,
        transition: "opacity 0.25s ease",
        pointerEvents: visible ? "auto" : "none",
      }}
      role="status"
      aria-live="polite"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        style={{ flexShrink: 0 }}
      >
        <path d="M20 6L9 17l-5-5" />
      </svg>
      <span>{text}</span>
      <button
        type="button"
        onClick={() => {
          setVisible(false);
          setTimeout(() => dispatch(hideNotification()), 300);
        }}
        style={{
          background: "none",
          border: "none",
          color: "rgba(255,255,255,0.75)",
          cursor: "pointer",
          fontSize: "12px",
          fontWeight: 700,
          letterSpacing: "0.05em",
          padding: 0,
          textTransform: "uppercase",
        }}
      >
        Close
      </button>
    </div>
  );
};

export { NotificationBar, NotificationBar as default };
